import React from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useGetNotifications } from '../services/notification.service';

const NotificationBadge = ({ className = "" }) => {
  const { data } = useGetNotifications();
  const unreadCount = data?.unread || 0;

  return (
    <Link 
      to="/notifications"
      className={`p-2 text-gray-400 hover:text-gray-600 relative transition-colors duration-200 focus:outline-none ${className}`}
    >
      <Bell size={20} />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-medium border-2 border-white">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Link>
  );
};

export default NotificationBadge;
